import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    sectionTitle: {
      color: theme.gray800,
      fontSize: 16,
    },
    sectionSubtitle: {
      color: theme.gray500,
      fontSize: 12,
    },
    stepper: {
      marginBottom: theme.spacing(19),
    },
    stepperWrapper: {
      maxWidth: "500px",
      margin: "0 auto",
    },
    separator: {
      borderBottom: `1px solid ${theme.gray100}`,
      position: "relative",
      left: "-20px",
      width: "calc(100% + 40px)",
    },
    contentWrapper: {
      maxWidth: "1198px",
      margin: "0 auto",
      padding: theme.spacing(0, 2),
    },
    form: {
      height: "calc(100% - 200px)",
      overflow: "auto",
    },
    disabledCampaignInfoWrapper: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(2),
      margin: theme.spacing(-2, 0, 4),
    },
    lockIcon: {
      width: "16px",
      height: "16px",
      color: theme.orange600,
      "& path": {
        color: theme.orange600,
        stroke: theme.orange600,
        strokeWidth: "1.5px",
      },
    },
    footer: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%",
      padding: theme.spacing(10, 12),
      height: "80px",
      borderTop: `1px solid ${theme.gray100}`,
      backgroundColor: theme.white00,
    },
    submitWrapper: {
      margin: 0,
    },
    content: {
      position: "relative",
      height: `calc(100vh - 63px)`,
    },
    sectionNextBtn: {
      display: "block",
      marginLeft: "auto",
      marginTop: theme.spacing(8),
    },
    sectionTitleWrapper: {
      display: "flex",
      gap: theme.spacing(8),
    },
    triggerBox: {
      display: "flex",
      alignItems: "center",
      backgroundColor: theme.primary50,
      color: theme.primary500,
      borderRadius: "4px",
      gap: theme.spacing(3),
      fontSize: "12px",
      padding: theme.spacing(0, 4),

      "& span": {
        lineHeight: 0,
      },
      "& svg": {
        width: "12px",
        height: "12px",
      },
    },
    img: {
      marginTop: theme.spacing(4),
    },
    warningText: {
      marginBottom: theme.spacing(8),
    },
  }),
);
